/**
 * @desc 立即下载邮件
 */
const URL = "/rantion-mail";
import http, { updateResponse } from "@/http";
export function request(mailAccountCode: string | number, options?: any) {
  return updateResponse(
    http(URL + `/mail/mailAccount/load/${mailAccountCode}`, {
      method: "POST",

      ...options,
    }),
  );
}
